import { XMarkIcon } from '@heroicons/react/24/solid'
import DebouncedInput from './table/DebouncedInput'

type Props = {
    keyword: string
    onKeywordChange: (keyword: string) => void
    onSearch: (keyword: string) => void
}

/**
 * This is a simple component - it is just to do with UI and externalises the search keyword and search function
 *
 * So it not responsible for storing the search keyword in the URL, not is it responsible for deciding when
 * to initiate a search.
 *
 */
function SearchInput(props: Props) {
    const { keyword, onKeywordChange, onSearch } = props

    function handleChange(value: string | number) {
        onKeywordChange(value.toString())
    }

    function doSearchReset() {
        onKeywordChange('')
        onSearch('')
    }

    return (
        <div className="flex">
            {/* Single bordered pill (border + shadow on one element) to match the sibling
                filter controls. The input and reset button are borderless children so there's
                no internal seam — a layered input-border-over-wrapper-shadow was rendering as a
                stray line under the box. Focus state lives on the container via focus-within. */}
            <div className="flex h-9 items-center rounded-md border border-ink-200 bg-white shadow-sm transition-all duration-200 hover:border-ink-300 focus-within:border-arwen-500 focus-within:ring-1 focus-within:ring-arwen-500">
                <DebouncedInput
                    value={keyword}
                    onChange={handleChange}
                    onKeyUp={(event) => {
                        if (event.key === 'Escape') {
                            onKeywordChange('')
                            onSearch('')
                        }
                    }}
                    placeholder="Search..."
                    className="block h-full w-full border-0 bg-transparent pl-3 text-sm text-ink-700 placeholder:text-ink-400 focus:ring-0"
                />
                <button
                    type="button"
                    className="flex h-full items-center px-2 text-ink-400 hover:text-ink-700 focus:outline-none transition-colors duration-150 active:scale-95"
                    onClick={doSearchReset}
                >
                    <XMarkIcon className="h-4 w-4" aria-hidden="true" />
                </button>
            </div>
        </div>
    )
}

export default SearchInput
